module.exports = __webpack_public_path__ + "static/img/icon_hitem4.c71a8db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem4.png
// module id = j/S6
// module chunks = 21